export default __webpack_public_path__ + "static/media/Union-disabled.c24956cd.webp";